import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#2C3E50',      // 深邃的靛青色
          secondary: '#E74C3C',    // 优雅的红色
          accent: '#9B59B6',       // 高贵的紫色
          background: '#ECF0F1',   // 清新的浅灰色
          surface: '#FFFFFF',      // 纯白色
          error: '#C0392B',        // 深红色
          info: '#3498DB',         // 明亮的蓝色
          success: '#27AE60',      // 翠绿色
          warning: '#F39C12',      // 金黄色
          tertiary: '#1ABC9C',     // 清新的青绿色
          quaternary: '#8E44AD'    // 深紫色
        },
      },
    },
  },
})

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(vuetify)

app.mount('#app')
